import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Header from './components/layout/Header';
import Footer from './components/layout/Footer';
import HomePage from './pages/HomePage';
import ElectionsPage from './pages/ElectionsPage';
import ElectionDetailPage from './pages/ElectionDetailPage';
import CreateElectionPage from './pages/CreateElectionPage';
import VotePage from './pages/VotePage';
import ResultsPage from './pages/ResultsPage';
import NotFoundPage from './pages/NotFoundPage';
import './styles/global.css';

function App() {
  return (
    <Router>
      <div className="app">
        <Header />
        <main className="container">
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/elections" element={<ElectionsPage />} />
            <Route path="/elections/create" element={<CreateElectionPage />} />
            <Route path="/elections/:id" element={<ElectionDetailPage />} />
            <Route path="/elections/:id/vote" element={<VotePage />} />
            <Route path="/elections/:id/results" element={<ResultsPage />} />
            <Route path="*" element={<NotFoundPage />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </Router>
  );
}

export default App;